module.exports = __webpack_public_path__ + "img/logo_h_w.9a6da84d.png";